<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
          <d-row>

            <d-col md="6" class="form-group">
              <d-form @submit.prevent="saveQuotationTypes()">
                <type-form-template title="Tipos de Orçamentos" :list="quotationTypes"/>
              </d-form>
            </d-col>

            <d-col md="6" class="form-group">
              <d-form @submit.prevent="saveQuotationPaymentTypes()">
                <type-form-template title="Condições de pagamentos" :list="paymentTypes"/>
              </d-form>
            </d-col>

          </d-row>

      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import QuotationService from '_services/rest/modules/quotation';
import { stringfy } from '_utils/string';
import { parseApiList } from '../../quotation/components/installmentsPlan';
import TypeFormTemplate from './TypesFormTemplate.vue';

export default {
  name: 'quotation-types-form',
  components: {
    TypeFormTemplate,
  },
  data() {
    return {
      loading: false,
      paymentTypes: [],
      quotationTypes: [],
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    formatSlug(options) {
      return options.map(option => {
        option.slug = stringfy(option.name);
        return option;
      });
    },
    getQuotationTypes() {
      QuotationService.getTypeOptions()
        .then(response => {
          this.quotationTypes = parseApiList(response);
        });
    },
    getPaymentType() {
      QuotationService.getPaymentTypeOptions()
        .then(response => {
          this.paymentTypes = parseApiList(response);
        });
    },
    saveQuotationPaymentTypes() {
      this.loading = true;
      this.formatSlug(this.paymentTypes);
      QuotationService.saveQuotationPaymentTypes({ paymentTypes: this.paymentTypes })
        .then(() => this.activeAlert({ message: 'Condições salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    saveQuotationTypes() {
      this.loading = true;
      this.formatSlug(this.quotationTypes);
      QuotationService.saveQuotationTypes({ types: this.quotationTypes })
        .then(() => this.activeAlert({ message: 'Tipos salvos com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
  },
  mounted() {
    this.getQuotationTypes();
    this.getPaymentType();
  },
};
</script>
